<app-navbar title="Dodatek i Potrącenie">
	<button class="me-2" mat-raised-button color="primary" (click)="save()" *ngIf="editable">
		<i class="fas fa-check"></i>
		Zapisz
	</button>
	<button
		class="me-2"
		mat-raised-button
		color="primary"
		*ngIf="!editable && auth.permissionsByCode()[Permissions.ADDITION_AND_DEDUCTION_ADDING]"
		(click)="editable = true"
	>
		<i class="fas fa-check"></i>
		Edytuj
	</button>
	<button class="me-2" mat-raised-button color="warn" routerLink="../">
		<i class="fas fa-chevron-left"></i>
		Powrót
	</button>
</app-navbar>

<mat-tab-group dynamicHeight>
	<mat-tab label="Dane podstawowe">
		<div class="container">
			<div class="form-floating my-4">
				<ng-select
					name="settlementBonusNameId"
					[(ngModel)]="data.settlementBonusNameId"
					[multiple]="false"
					placeholder="Typ"
					[disabled]="data.confirmButton || !editable"
					(change)="clearValue()"
				>
					<ng-option *ngFor="let item of settlementBonusName" [value]="item.id">{{ item.name }}</ng-option>
				</ng-select>
			</div>
			<span *ngIf="data.settlementBonusNameId === '1'">
				<mat-form-field class="mt-2">
					<mat-label>Zakres</mat-label>
					<mat-date-range-input [disabled]="!editable" [rangePicker]="picker">
						<input matStartDate matInput placeholder="Data od" [(ngModel)]="termRange.start" />
						<input matEndDate matInput placeholder="Data do" [(ngModel)]="termRange.end" />
					</mat-date-range-input>
					<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-date-range-picker #picker></mat-date-range-picker>
				</mat-form-field>
			</span>
			<span *ngIf="termRange.end && data.settlementBonusNameId === '1'">
				<button class="ms-3" mat-raised-button color="primary" (click)="generateTerms()">
					<i class="fas fa-plus"></i>
					Generuj terminy
				</button>
			</span>

			<div class="form-floating my-4">
				<ng-select
					name="ownerId"
					[(ngModel)]="data.ownerId"
					[multiple]="false"
					placeholder="Imie Nazwisko"
					[disabled]="data.confirmButton || !editable"
				>
					<ng-option *ngFor="let item of drivers" [value]="item.id"
						>{{ item.last_name }} {{ item.first_name }}
					</ng-option>
				</ng-select>
			</div>
			<div class="form-floating my-4">
				<input
					type="date"
					name="date"
					[(ngModel)]="data.date"
					class="form-control"
					[disabled]="data.confirmButton || !editable"
				/>
				<label for="date">Data</label>
			</div>
			<div class="form-floating my-4">
				<ng-select
					name="vehicleId"
					[(ngModel)]="data.vehicleId"
					[multiple]="false"
					placeholder="Pojazd"
					[disabled]="data.confirmButton || !editable"
				>
					<ng-option *ngFor="let item of vehicles" [value]="item.id"
						>{{ item.name }} {{ item.registrationNumber }}
					</ng-option>
				</ng-select>
			</div>

			<div class="form-floating my-4">
				<input
					type="text"
					[(ngModel)]="data.comment"
					name="comment"
					class="form-control"
					[disabled]="data.confirmButton || !editable"
				/>
				<label for="comment">Komentarz</label>
			</div>
			<div class="form-floating my-4">
				<input
					type="text"
					[(ngModel)]="data.eventId"
					name="eventId"
					class="form-control"
					[disabled]="data.confirmButton || !editable"
				/>
				<label for="comment">ID Wydarzenia</label>
			</div>
			<div class="form-floating my-4">
				<input
					type="number"
					[(ngModel)]="data.value"
					name="value"
					class="form-control"
					(keyup)="checkSettlementKind()"
					[disabled]="data.confirmButton || !editable"
				/>
				<label for="discountValue">Wartość</label>
			</div>
			<ng-select
				name="valueCurrencyId"
				[(ngModel)]="data.valueCurrencyId"
				[multiple]="false"
				placeholder="Wartość waluta"
				[disabled]="data.confirmButton || !editable"
			>
				<ng-option *ngFor="let item of currency" [value]="item.id">{{ item.name }}</ng-option>
				<label for="discountValue">Wartość waluta</label>
			</ng-select>
			<ng-select
				name="settlementCurrencyId"
				[(ngModel)]="data.settlementCurrencyId"
				[multiple]="false"
				placeholder="Rozliczenie waluta"
				[disabled]="data.confirmButton || !editable"
			>
				<ng-option *ngFor="let item of currency" [value]="item.id">{{ item.name }}</ng-option>
				<label for="discountValue">Wartość waluta</label>
			</ng-select>
			<div class="form-floating my-4">
				<ng-select
					name="confirmPerson"
					[(ngModel)]="data.confirmPerson"
					[multiple]="false"
					placeholder="Osoba, która ma zatwierdzić dodatek/potrącenie"
					[disabled]="data.confirmButton || !editable"
				>
					<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
				</ng-select>
			</div>
			<div class="form-floating my-4">
				ZATWIERDZENIE DODATKU i POTRĄCENIA
				<button
					type="button"
					class="btn"
					name="confirm"
					[ngClass]="{
						'btn-success': data.confirmButton,
						'btn-outline-danger': !data.confirmButton,
					}"
					(click)="confirm('confirmBonus')"
					[disabled]="editable"
				>
					Zatwierdź
				</button>
				{{ data.confirm }}
			</div>
			<div class="form-floating my-4" *ngIf="['3'].includes(data.settlementBonusNameId)">
				ZATWIERDZENIE WARSZTAT
				<button
					type="button"
					class="btn"
					name="confirm"
					[ngClass]="{
						'btn-success': data.workshopButton,
						'btn-outline-danger': !data.workshopButton,
					}"
					(click)="confirm('confirmWorkshop')"
					[disabled]="editable"
				>
					Zatwierdź
				</button>
				{{ data.workshop }}
				<div class="form-floating my-4">
					<input type="text" [(ngModel)]="data.workshopComment" name="workshopComment" class="form-control" />
					<label for="workshopComment">Komentarz Warsztat</label>
				</div>
			</div>
		</div>
		<div class="container col-auto my-4">
			<fieldset [disabled]="!editable">
				<mat-table #dataTable [(dataSource)]="data.terms" matSort matSortActive="month" matSortDirection="asc">
					<ng-container matColumnDef="lp">
						<mat-header-cell *matHeaderCellDef mat-sort-header> LP </mat-header-cell>
						<mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="month">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Miesiąc </mat-header-cell>
						<mat-cell *matCellDef="let element; let i = index">
							<input type="date" name="date_{{ i }}" [(ngModel)]="element.month" class="form-control" />
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="value">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Wartość: {{ labelValue }} </mat-header-cell>
						<mat-cell *matCellDef="let element; let i = index">
							<input
								type="number"
								name="number_{{ i }}"
								step="0.01"
								[(ngModel)]="element.value"
								class="form-control"
								(keyup)="calculateValue(data)"
							/>
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="currency">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Waluta </mat-header-cell>
						<mat-cell *matCellDef="let element">
							{{ element.currency }}
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="comment">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Komentarz </mat-header-cell>
						<mat-cell *matCellDef="let element; let i = index">
							<input type="text" name="text_{{ i }}" [(ngModel)]="element.comment" class="form-control" />
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="toDelete">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Do usunięcia </mat-header-cell>
						<mat-cell *matCellDef="let element; let i = index"
							><button
								[disabled]="element.isSettled === SettlementBonusKinds.FLIX"
								class="btn"
								(click)="deleteTerm(element)"
								[ngClass]="{
									'btn-danger': element.toDelete,
									'btn-outline-danger': !element.toDelete,
								}"
							>
								Do usunięcia
							</button></mat-cell
						>
					</ng-container>
					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
				</mat-table>
				<div class="d-grid gap-2">
					<button mat-raised-button color="primary" (click)="addPos()" [disabled]="!editable">
						<i class="fas fa-plus"></i>
						Dodaj pozycję
					</button>
				</div>
			</fieldset>
		</div>
	</mat-tab>
	<mat-tab label="Załączniki">
		<div class="d-flex">
			<button mat-raised-button color="accent">
				<input class="ng-hide" id="input-file-id" type="file" (change)="uploadFile($event)" />
				<label for="input-file-id" class="md-button md-raised md-primary"
					><i class="fa-solid fa-file-circle-plus"></i> Wgraj zdjęcie z pliku</label
				>
			</button>
		</div>

		<mat-table #dataTableFiles [dataSource]="data.files" matSort matSortActive="id" matSortDirection="asc">
			<ng-container matColumnDef="url">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Zjęcie </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<img [src]="element.url" width="50%" height="50%" />
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="download">
				<mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<a [href]="element.url">Pobierz</a>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="toDelete">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Do usunięcia </mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index"
					><button
						class="btn"
						(click)="deleteFile(element)"
						[ngClass]="{
							'btn-danger': element.toDelete,
							'btn-outline-danger': !element.toDelete,
						}"
					>
						Do usunięcia
					</button></mat-cell
				>
			</ng-container>
			<mat-header-row *matHeaderRowDef="displayedColumns2"></mat-header-row>
			<mat-row *matRowDef="let row; columns: displayedColumns2"></mat-row>
		</mat-table>
	</mat-tab>
	<mat-tab label="Historia zmian">
		<mat-table
			#dataTableFiles
			[dataSource]="settlementBonusHistory"
			matSort
			matSortActive="id"
			matSortDirection="asc"
		>
			<ng-container matColumnDef="editBy">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Użytkownik </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{ element.editByName }}</mat-cell></ng-container
			>
			<ng-container matColumnDef="editAt">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Data zmiany </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{ element.editAt | formatDateTime }}</mat-cell>
			</ng-container>
			<ng-container matColumnDef="detail">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Podgląd </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<a
						mat-raised-button
						color="primary"
						target="_blank"
						[routerLink]="'../../settlementBonusHistoryDetail/' + element.id"
					>
						>>
					</a></mat-cell
				>
			</ng-container>
			<mat-header-row *matHeaderRowDef="historyBonusTable"></mat-header-row>
			<mat-row *matRowDef="let row; columns: historyBonusTable"></mat-row>
		</mat-table>
	</mat-tab>
</mat-tab-group>
